import cx from 'clsx';
import React, { useRef } from 'react';

import { MODAL_RENDERERS } from '@constants/modalRenderers';

import { useClickAway } from '@hooks/useClickAway';

import { selectActiveModal, selectSecondaryModal, useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const ModalProvider = () => {
  const ref = useRef(null);

  const { setModalClose } = useModalActions();
  const { name: mainModalName, options: mainModalOptions, awayClick } = selectActiveModal();
  const { name: secondaryModalName, options: secondaryModalOptions } = selectSecondaryModal();

  useClickAway(ref, setModalClose, awayClick && !secondaryModalName);

  if (!mainModalName && !secondaryModalName) {
    return null;
  }

  const ModalRenderer = MODAL_RENDERERS[mainModalName] || null;
  const ModalSecondRenderer = MODAL_RENDERERS[secondaryModalName] || null;

  return (
    <>
      {ModalRenderer && (
        <div className={cx(style.wrapper, { [style.withoutBg]: secondaryModalName })}>
          <div ref={ref} className={style.modal}>
            <ModalRenderer {...mainModalOptions} />
          </div>
        </div>
      )}
      {ModalSecondRenderer && (
        <div className={style.wrapper}>
          <div className={style.modal}>
            <ModalSecondRenderer {...secondaryModalOptions} type={'secondary'} />
          </div>
        </div>
      )}
    </>
  );
};

export default ModalProvider;
